import * as React from 'react';
import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import Analytics from './components/Analytics';
import Copyright from './components/Copyright';

import IRPCalculatorPage from './pages/IRPCalculatorPage';
import { SUPPORTED_LANGUAGES } from './i18n';

const LANGUAGE_CODES = SUPPORTED_LANGUAGES.map(({ code }) => code);

//
// /:lng -- the path is the source of truth for the active language, so a shared
// link always opens in the language it was shared in.
//
function LocalizedPage({ lng }) {
  const { i18n } = useTranslation();

  useEffect(() => {
    if (i18n.resolvedLanguage !== lng) {
      i18n.changeLanguage(lng);
    }
  }, [lng, i18n]);

  return <IRPCalculatorPage />;
}

//
// "/" carries hreflang x-default: pick the visitor's language from the browser
// (i18next has already run its detector) and hand them the matching URL.
//
function LanguageRedirect() {
  const { i18n } = useTranslation();
  const detected = LANGUAGE_CODES.includes(i18n.resolvedLanguage) ? i18n.resolvedLanguage : 'es';

  return <Navigate to={`/${detected}`} replace />;
}

export default function App() {
  const theme = createTheme();

  return (

    <ThemeProvider theme={theme}>

      <Analytics />

      <Routes>
        <Route path="/" element={<LanguageRedirect />} />
        {LANGUAGE_CODES.map((code) => (
          <Route key={code} path={`/${code}`} element={<LocalizedPage lng={code} />} />
        ))}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Copyright />

    </ThemeProvider>
  );
}
